/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import ThreeDotsMenu from 'DesignSystem/ThreeDotsMenu/index'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/Content/Claim/Content/Charges/Charge/Actions"
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ThreeDotsMenu
  viewPath={`${viewPath}/ThreeDotsMenu`}
 isVerticalDots={true}
 data="options"
 from={optionsValueData}
 onClick={onClick}
 marginLeft="auto"
 paddingTop={0}
 paddingLeft={0}
 paddingBottom={0}
 paddingRight={0}
 right={0}
 height={90}
/>
{children}
</React.Fragment>)
}